import { render } from "./Series.vue?vue&type=template&id=10530621"
import script from "./Series.vue?vue&type=script&lang=js"
export * from "./Series.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__